import { useMeasuredElement } from '@ooh/ui/components/use-measured-element';
import { WORKSPACE_TABS_BAR_HEIGHT_PX } from '../../workspace/workspace-shell';

export interface UnitsTableStickyHeaderOffset {
  toolbarRef: (node: HTMLDivElement | null) => void;
  stickyHeaderOffsetPx: number;
}

/**
 * Measures the units-tab's own sticky toolbar block — its height is dynamic (the
 * map/availability strip toggle it taller) — and adds the workspace tabs bar's own
 * height, giving `DataTable`'s `stickyHeaderOffsetPx` the pixel offset its sticky
 * header must clear.
 */
export function useUnitsTableStickyHeaderOffset(): UnitsTableStickyHeaderOffset {
  const [toolbarHeight, toolbarRef] = useMeasuredElement<HTMLDivElement>(
    (node) => node.getBoundingClientRect().height,
  );
  return { toolbarRef, stickyHeaderOffsetPx: toolbarHeight + WORKSPACE_TABS_BAR_HEIGHT_PX };
}
